import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "header__left" }
const _hoisted_2 = { class: "header__center" }
const _hoisted_3 = {
  key: 0,
  class: "header__title"
}
const _hoisted_4 = {
  key: 1,
  class: "header__logo"
}
const _hoisted_5 = { class: "header__right" }
const _hoisted_6 = {
  key: 0,
  class: "header-notifications__count"
}

import {ref} from "vue";
import "./Header.scss";
import {RouterLink, useRoute, useRouter} from "vue-router";
import Icon from "@/components/Icon/Icon.vue";
import {useUserStore} from "@/stores/userStore";
import {storeToRefs} from "pinia";
import {useNotificationsStore} from "@/stores/notificationsStore";

interface Props{
	title? : string,
	back? : boolean | string | Function,
	inversed? : boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  props: {
    title: {},
    back: { type: [Boolean, String, Function], default: false },
    inversed: { type: Boolean, default: false }
  },
  setup(__props: any) {

let props = __props;

let router = useRouter();
let notificationsStore = useNotificationsStore();

let {notifications, unread} = storeToRefs(notificationsStore);

let goBack = () => {

	if(typeof props.back === 'string'){
		router.push(props.back);
	}else if(typeof props.back === 'function'){
		props.back();
	}else{
		router.back();
	}

}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["header", {'header--inversed' : _unref(props).inversed}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(props).back)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(goBack) && _unref(goBack)(...args))),
            class: "header__back"
          }, [
            _createVNode(Icon, { name: "left" })
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.title)
        ? (_openBlock(), _createElementBlock("h1", _hoisted_3, _toDisplayString(_ctx.title), 1))
        : (_openBlock(), _createElementBlock("i", _hoisted_4))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "right", { goBack: _unref(goBack) }, () => [
        _createVNode(_unref(RouterLink), {
          color: "brand",
          to: "/notifications",
          class: _normalizeClass(["header__notifications header-notifications", {'header-notifications--inversed' : _unref(props).inversed}])
        }, {
          default: _withCtx(() => [
            _createVNode(Icon, { name: "notifications" }),
            (_unref(unread) > 0)
              ? (_openBlock(), _createElementBlock("i", _hoisted_6, _toDisplayString(_unref(unread)), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_unref(RouterLink), {
          color: "light",
          to: "/settings",
          class: "header__settings"
        }, {
          default: _withCtx(() => [
            _createVNode(Icon, { name: "settings" })
          ]),
          _: 1
        })
      ])
    ])
  ], 2))
}
}

})